import useAuth from '@hooks/auth.hook';
import { Avatar as MuiAvatar } from '@mui/material';
import { stringToColor } from '@utils/colors';
import { getInitials } from './Avatar.utils';

interface Props {
	height?: number;
	width?: number;
}

const Avatar: React.FC<Props> = ({ height = 44, width = 44 }) => {
	// Hooks
	const { getFullName } = useAuth();

	// Variables
	const fullName = getFullName() ?? '';

	return (
		<MuiAvatar sx={{ backgroundColor: stringToColor(fullName), height, width }}>
			{getInitials(fullName)}
		</MuiAvatar>
	);
};

export default Avatar;
